import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Box, Button, Container, Link, TextField } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import Loading from "../../components/loading/loading";
import { UserRoleFormData } from "../../interfaces/UserRoleFormData";
import { homeStyle } from "../../styles/container/home";
import { EditUserForm } from "./Component/EditUserForm";
import useViewModel from "./ViewModel";

function MasterUserRevamped() {
  const {
    data: { listRolesName, userList, loading },
    method: { onGetListRolesName, onGetUserList, onEditUserRole },
  } = useViewModel();

  const [dialogState, setDialogState] = useState(false);
  const [selectedData, setSelectedData] = useState<UserRoleFormData>({
    binusianId: "",
    roleName: "",
  });
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    onGetUserList();
    onGetListRolesName();
  }, []);

  const columns: GridColDef[] = [
    {
      field: "action",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderHeader: () => <b>Action</b>,
      renderCell: (params) => (
        <div
          style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
        >
          <Link
            onClick={(e) => {
              e.stopPropagation();
              setSelectedData({
                binusianId: params.row.binusianId,
                roleName: params.row.roleName,
              });
              setDialogState(true);
            }}
          >
            <EditOutlinedIcon className="pencilAction" />
          </Link>
        </div>
      ),
    },
    { field: "binusianId", width: 150, renderHeader: () => <b>Binusian ID</b> },
    {
      field: "name",
      width: 150,
      renderHeader: () => <b>Name</b>,
    },
    { field: "email", width: 200, renderHeader: () => <b>Email</b> },
    {
      field: "department",
      width: 250,
      renderHeader: () => <b>Department</b>,
      renderCell: (params) => (
        <div>
          {params.row.department == null || params.row.department == "null"
            ? params.row.businessUnit
            : params.row.department}
        </div>
      ),
    },
    { field: "title", width: 200, renderHeader: () => <b>Title</b> },
    { field: "leader", width: 150, renderHeader: () => <b>Leader</b> },
    { field: "roleName", width: 140, renderHeader: () => <b>Role Name</b> },
  ];

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        User Management
        <hr />
      </Box>
      <br />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          marginBottom: "10px",
        }}
      >
        <div className="searchDataTable">
          <TextField
            value={searchText}
            placeholder="Search"
            variant="outlined"
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onGetUserList(searchText);
              }
            }}
          />
          <Button
            onClick={() => onGetUserList(searchText)}
            style={{ padding: 0, minWidth: "40px" }}
          >
            <SearchOutlinedIcon className="black" />
          </Button>
        </div>
      </Box>

      <div style={{ width: "100%", backgroundColor: "white" }}>
        <DataGrid
          rows={userList}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          getRowId={(row) => row.binusianId}
          pageSizeOptions={[5, 10]}
          autoHeight
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick
        />
      </div>

      <EditUserForm
        openDialog={dialogState}
        roleList={listRolesName}
        handleDialogClose={() => setDialogState(false)}
        handleDialogEdit={() => {
          onEditUserRole(selectedData);
        }}
        defaultRoleName={selectedData?.roleName}
        handleChangeValue={(e) => {
          setSelectedData((prev) => ({ ...prev, roleName: e }));
        }}
      />

      <Loading open={loading} />
    </Container>
  );
}

export default MasterUserRevamped;
